import React from 'react';
import { parse } from 'query-string';
import { withRouter } from 'react-router-dom';
import { camelizeKeys } from 'humps';

type Props = {
  location: { search: string },
};

export default function injectFlightSearchParams(WrappedComp) {
  const FlightSearchParams = (props: Props) => {
    const queryParams = camelizeKeys(parse(props.location.search));

    let isOneWay = false;
    const { tripType } = queryParams;

    if (tripType && (tripType.toLowerCase() === 'o')) {
      isOneWay = true;
    };

    return (
      <WrappedComp
        {...props}
        queryParams={queryParams}
        isOneWay={isOneWay}
        isRoundTrip={!isOneWay}
      />
    );
  };

  return withRouter(FlightSearchParams);
}



// WEBPACK FOOTER //
// ./src/screens/Flights/Common/injectQueryParams.js